export default function InputGroup({ label, id, children }) {
    return (
        <div className="flex flex-col gap-2">
            <label htmlFor={id} className="font-medium text-sm text-gray-700">
                {label}
            </label>
            {children}
        </div>
    );
}
